import * as React from 'react';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';
import HeroBentoModuleRenderer from 'bundles/campaigns/module-renderers/CampaignHeroModuleRenderer/HeroBentoModuleRenderer';
import HeroModuleRenderer from 'bundles/campaigns/module-renderers/CampaignHeroModuleRenderer/HeroModuleRenderer';

export const useShouldShowCampaignHeroModule = () => {
  const { campaignData, loading } = useCampaignModulesData();
  return !!campaignData?.heroModule?.contentDataJson || loading;
};

const CampaignHeroModuleRenderer = () => {
  const { campaignData } = useCampaignModulesData();

  if (!useShouldShowCampaignHeroModule()) {
    return null;
  }

  const content = campaignData?.heroModule?.contentDataJson;

  if (content?.__typename === 'PromoTemplateHero') {
    return <HeroModuleRenderer />;
  } else if (content?.__typename === 'HeroBentoModule') {
    return <HeroBentoModuleRenderer />;
  }

  return null;
};

export default CampaignHeroModuleRenderer;
